import { getUserData } from './wam';
import { queryParam } from './queryString';
import { isPartner, isEmployee, isDealerRep } from './roles';
import { User } from '../types/user';

export function isImpersonating(user): boolean {
  const impersonatedUserId = queryParam('client-id');
  const userId = getUserData()?.clientId;
  
  const isAgentImpersonating =
      Boolean(impersonatedUserId) && (String(userId) !== String(impersonatedUserId));
  
  return isAgentImpersonating || isPartner(user) || isEmployee(user);
}

export function isProxyingItself(user): boolean {
  const impersonatedUserId = queryParam('client-id');
  const userId = getUserData()?.clientId;

  const userWithProxyRole = isPartner(user) || isEmployee(user);

  if(!impersonatedUserId) {
    return userWithProxyRole;
  }
  return (userWithProxyRole &&
      String(userId) === String(impersonatedUserId)
  );
}

export function isImpersonationNotAvailable(user): boolean {
  return !isPartner(user) && !isEmployee(user);
}

export function isDealerImpersonatingFarmer(user: User, impersonatedUser: User | undefined): boolean {
  if (!user.details.roles || !impersonatedUser?.details.roles) {
    return false;
  }
  return isDealerRep(user) && !isDealerRep(impersonatedUser);
}

export function isDealerImpersonatingUser(user: User, impersonatedUser: User | undefined): boolean {
  if (!user.details.roles || !impersonatedUser?.details.roles) {
    return false;
  }
  return isDealerRep(user) && user.uuid !== impersonatedUser.uuid;
}

export function isEmployeeImpersonatingUser(user: User, impersonatedUser: User | undefined): boolean {
  if (!user.details.roles || !impersonatedUser?.details.roles) {
    return false;
  }
  return isEmployee(user) && user.uuid !== impersonatedUser.uuid;
}